import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { IonIcon } from '@ionic/angular/standalone';

import { map, shareReplay } from 'rxjs/operators';

import { SvgIconService } from '../../../services/svg-icon/svg-icon.service';
import { IconNames } from '../../../shared';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'lib-svg-icon',
    standalone: true,
    imports: [CommonModule, IonIcon],
    templateUrl: './svg-icon.component.html',
    styleUrl: './svg-icon.component.css'
})
export class SvgIconComponent implements OnInit {
    @Input() public iconName: IconNames | undefined;
    @Input() public size!: number;
    @Input() public sizeType!: 'xsmall' | 'small' | 'default' | 'large' | 'xlarge';
    @Input() public color!: string;
    @Input() useFillAsStrokeColor: boolean = false;
    @Input() classes!: string;
    @Input() roundBorder!: boolean;
    @Input() borderColor!: string;
    @Input() borderWidth!: string;
    @Input() borderSpacing!: number;
    @Input() ariaLabel!: string;
    @Input() ariaHidden!: boolean;
    @Input() backgroundColor!: string;

    public sanitizedSvgContent: SafeHtml = '';
    public svgPath: string = '';
    public useIonIcon: boolean = false;
    private iconPath: string = '';

    constructor(
        private cdr: ChangeDetectorRef,
        private sanitizer: DomSanitizer,
        private http: HttpClient,
        private svgIconService: SvgIconService
    ) {
        this.iconPath = this.svgIconService.getIconAssetPath();
        this.useIonIcon = this.svgIconService.getUseIonIconComponent();
    }

    ngOnInit(): void {
        if (this.useIonIcon) {
            this.loadPathForIonIcon();
        } else {
            this.loadSvg();
        }
    }

    loadPathForIonIcon() {
        if (!this.iconName) return;
        const pathFromObject = this.svgIconService.getIconFileNameFromObject(this.iconName);

        const svgPath = `${this.iconPath}${pathFromObject}`;

        this.svgPath = svgPath;
    }

    loadSvg(): void {
        if (!this.iconName) return;
        const pathFromObject = this.svgIconService.getIconFileNameFromObject(this.iconName);
        if (!pathFromObject) return;

        const svgPath = `${this.iconPath}${pathFromObject}`;

        if (!this.svgIconService.svgIconMap.has(svgPath)) {
            const svg$ = this.http.get(svgPath, { responseType: 'text' }).pipe(
                map(svg => this.sanitizer.bypassSecurityTrustHtml(svg)),
                shareReplay(1)
            );
            this.svgIconService.svgIconMap.set(svgPath, svg$);
        }

        const cachedSvg = this.svgIconService.svgIconMap.get(svgPath);

        cachedSvg?.subscribe({
            next: svg => {
                this.sanitizedSvgContent = svg;
                this.cdr.detectChanges();
            },
            error: error => console.error(`Error loading SVG`, error)
        });
    }
}
